@if (folders == null || labels == null ) {
  <app-admin-spinner></app-admin-spinner>
}
@if (outlet.isActivated===false) {
  <div fxLayout="row table1" fxLayoutAlign="space-between center" fxLayoutGap="20px">
    <div fxFlex="5"></div>
    <div fxFlex="90">
      <div class="mat-elevation-z8">
        <button class="action-button btn btn-success" (click)="openInsertDialog()">
          {{labels.lblAddFolder}}
        </button>
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="folder-tree">
          <!-- For leaf nodes -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li class="mat-tree-node">
              <!-- use a disabled button to provide padding for tree leaf -->
              <button mat-icon-button disabled></button>
              <mat-icon class="mat-icon-rtl-mirror">folder</mat-icon>
              {{node.name}}
              <button class="btn btn-info action-button" (click)="openInsertTrainingsDialog(node._id, node.content)">
                {{labels.lblAddTraining}}
              </button>
              <button class="action-button btn btn-success" (click)="openInsertDialog(node._id)">
                {{labels.lblAddFolder}}
              </button>
              <button class="btn btn-warning action-button" (click)="openDeleteDialog(node)">
                {{labels.lblDelete}}
              </button>
            </li>
          </mat-tree-node>
          <!-- For expandable nodes -->
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <li>
              <div class="mat-tree-node">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'folder' : 'folder_open'}}
                </mat-icon>
                <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.name">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                {{node.name}}
                <button class="btn btn-info action-button" (click)="openInsertTrainingsDialog(node._id, node.content)">
                  {{labels.lblAddTraining}}
                </button>
                <button class="action-button btn btn-success" (click)="openInsertDialog(node._id)">
                  {{labels.lblAddFolder}}
                </button>
                <button class="btn btn-warning action-button" (click)="openDeleteDialog(node)">
                  {{labels.lblDelete}}
                </button>
              </div>
              <ul [class.folder-tree-invisible]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      </div>
    </div>
    <div fxFlex="5"></div>
  </div>
}

<router-outlet #outlet="outlet"></router-outlet>
